// Text block — factory + serializer. This is the single source of truth
// for what a text block persists (see "Block capability contract" in
// ../PLAN.md). The grid never asserts this shape itself.

let idCounter = 0;
const nextId = () => `text_${Date.now()}_${idCounter++}`;

export const DEFAULT_TEXT_VALUE = 'double click to edit';

export function createTextBlock(overrides = {}) {
  return {
    id: nextId(),
    text: DEFAULT_TEXT_VALUE,
    x: 0.2,
    y: 0.2,
    // Auto-measured from rendered content (see TextBlockLayer), not
    // user-set — included here so save/load round-trips them instead of
    // silently dropping them the way print_old's serializeForMongo did.
    width: undefined,
    height: undefined,
    fontSize: 16,
    color: '#000000',
    fontFamily: 'var(--ss-font-heading)',
    fontWeight: 'bold',
    fontStyle: 'normal',
    textAlign: 'left',
    // Whether this block's properties panel is collapsed. Persisted per
    // block (not localStorage, unlike other sidebar panels) since it's a
    // property of this specific block within this specific template, not
    // of the print designer UI in general — a localStorage key per block
    // would grow unbounded across templates with many blocks.
    collapsed: false,
    ...overrides,
  };
}

export function serializeTextBlock({
  id,
  text,
  x,
  y,
  width,
  height,
  fontSize,
  color,
  fontFamily,
  fontWeight,
  fontStyle,
  textAlign,
  collapsed,
}) {
  return { type: 'text', id, text, x, y, width, height, fontSize, color, fontFamily, fontWeight, fontStyle, textAlign, collapsed };
}
